import actionTypes from 'SRC/modules/redux/actionTypes'

export const setGroupCategories = (categories) => {
  return {
    type: actionTypes.SET_GROUP_CATEGORIES,
    payload: categories
  }
}
